import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { CatGoalRegionModel } from 'src/app/model/cat-goal-region.model';

@Injectable({
  providedIn: 'root'
})
export class CatGoalRegionService {
  private url:string;

  ////////////////
  constructor(
    private http:HttpClient
  ) {
    this.url=environment.services_url;
  }

  //
  catalog=()=> {
    return this.http.get(`${this.url}/CatGoalRegion/Catalog`)
      .pipe(
        map((resp:any)=> resp)
      );
  }
  getAll=()=> {
    return this.http.get(`${this.url}/CatGoalRegion/List`)
      .pipe(
        map((resp:any)=> resp)
      );
  }
  getAllActive=()=> {
    return this.http.get(`${this.url}/CatGoalRegion/List`)
      .pipe(
        map((resp:any)=> resp.filter(goal=> goal.activeId))
      );
  }

  
  save=(region:CatGoalRegionModel)=> {
    return this.http.post(`${this.url}/CatGoalRegion/SaveUpdate`, region)
      .pipe(
        map((resp:any)=> resp)
      );
  }
  update=(region:CatGoalRegionModel)=> {
    return this.http.post(`${this.url}/CatGoalRegion/SaveUpdate/${region.goalRegionId}`, region)
      .pipe(
        map((resp:any)=> resp)
      );
  }
}
